
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

const PaperContainer = styled("div")(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'left',
  justifyContent: 'left',
  [theme.breakpoints.up('md')]: {
    height: '100%'
  }
}));

const LoginHeader = ({text = ''}) => {
  return (
    <PaperContainer>
      <Typography component="h1" variant="h1" fontWeight="600">
        {text}
      </Typography>
    </PaperContainer>
  );
};

export default LoginHeader;